<template>
  <div class="container bg-white mt-1">
    <div class="p-48">
      <div v-if="!loading">
        <div class="border-bottom mb-3 d-flex justify-content-between py-3">
          <div>
            <button
              type="button"
              class="btn bg-white border-2 txt-grey-600 fw-600 bd-blur-gray mr-3"
              v-if="
                circle &&
                circle.created_by !== user_id &&
                circle_member &&
                (circle_member.status === 2 ||
                  circle_member.status === 0 ||
                  circle_member.status === 1)
              "
              @click="rejectMember(circle_member.id)"
            >
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.1771 10.5173H3.14291"
                  stroke="#98A2B3"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.7373 8.08789L13.1773 10.5179L10.7373 12.9479"
                  stroke="#98A2B3"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.08701 6.65707V5.87957C7.08701 4.18374 8.46117 2.80957 10.1578 2.80957H14.2278C15.9195 2.80957 17.2903 4.1804 17.2903 5.87207V15.1554C17.2903 16.8512 15.9153 18.2262 14.2195 18.2262H10.1487C8.45784 18.2262 7.08701 16.8546 7.08701 15.1637V14.3787"
                  stroke="#98A2B3"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{
                circle_member.status === 2
                  ? this.$t("circle_feature.lbl_leave_circle")
                  : circle_member.status === 0
                  ? this.$t("circle_feature.lbl_cancel_request")
                  : circle_member.status === 1
                  ? this.$t("circle_feature.lbl_decline")
                  : ""
              }}
            </button>

            <button
              type="button"
              class="btn bg-pri fw-600 text-white border-none px"
              v-if="
                circle &&
                circle.created_by !== user_id &&
                circle_member &&
                circle_member.status === 1
              "
              @click="acceptMember(circle_member.id)"
            >
              {{
                circle_member.status === 1
                  ? this.$t("circle_feature.lbl_accept")
                  : ""
              }}
            </button>

            <button
              type="button"
              class="btn bg-pri bd-pri text-white"
              v-if="circle && circle.created_by === user_id && !circle_member"
              @click="joinCircle"
            >
              {{ $t("circle_feature.lbl_request_join") }}
            </button>
            <button
              type="button"
              class="btn bg-white border-2 txt-grey-600 fw-600 bd-blur-gray"
              v-if="circle && circle.created_by === user_id"
              @click="deleteCircle"
            >
              {{ $t("circle_feature.lbl_del_circle") }}
            </button>
          </div>
          &nbsp;
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="goToList"
            class="cursor-pointer"
          >
            <path
              d="M6 18.4998L17.9998 6.5"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.9998 18.4998L6 6.5"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <div class="row">
          <div class="col-lg-6 col-xl-7">
            <div class="d-flex justify-content-between">
              <p class="fs-24 fw-600 max-line-2" v-if="!updating_info">
                {{ circle && circle.name }}
              </p>
              <input
                v-if="updating_info"
                type="text"
                class="fs-24 fw-600 form-control bg-white border mb-3"
                v-model="form_edit.name"
              />
              <a
                v-if="!updating_info && isAdmin"
                class="fs-14 fw-500 txt-pri text-decoration-underline"
                href="javascript:;"
                @click="updating_info ^= true"
              >
                {{
                  updating_info
                    ? this.$t("multidisciplinary_board.btn_cancel")
                    : this.$t("lbl_edit")
                }}
              </a>
            </div>
            <div class="d-flex" :class="updating_info ? 'mb-0' : 'mb-3'">
              <div class="icinfo">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14 17H4V19H14V17ZM20 9H4V11H20V9ZM4 15H20V13H4V15ZM4 5V7H20V5H4Z"
                    fill="#84818A"
                  />
                </svg>
              </div>
              <p class="white-s-pre" v-if="!updating_info">
                {{ circle && circle.description }}
              </p>
              <textarea
                v-if="updating_info"
                rows="5"
                v-model="form_edit.description"
                class="form-control bg-white border mb-3"
              ></textarea>
            </div>
            <div v-if="updating_info" class="d-flex items-center mb-3">
              <div class="icinfo mr-3" v-if="form_edit.logo">
                <img
                  class="w-24 h-24 object-contain"
                  :src="form_edit.logo"
                  :alt="form_edit.name"
                />
              </div>
              <div class="w-full">
                <div class="mb-1 font-medium text-black">
                  {{ $t("lbl_upload_logo_circle") }}
                </div>
                <div class="cs-input-file" @click="onShowPickLogo">
                  <div class="cs-select-file">{{ $t("lbl_select_file") }}</div>
                  <div class="flex items-center justify-center flex-1">
                    {{ $t("lbl_no_file_selected") }}
                  </div>
                </div>
                <input
                  v-show="false"
                  id="circle-file-logo"
                  class="form-control bg-white border mb-0"
                  name="circle-file-logo"
                  type="file"
                  accept="image/*"
                  @change="(e) => onSelectFile(e, 'logo')"
                />
              </div>
            </div>
            <div v-if="updating_info" class="d-flex items-center mb-3">
              <div class="icinfo mr-3" v-if="form_edit.background">
                <img
                  class="w-24 h-24 object-contain"
                  :src="form_edit.background"
                  :alt="form_edit.name"
                />
              </div>
              <div class="w-full">
                <div class="mb-1 font-medium text-black">
                  {{ $t("lbl_upload_background_photo") }}
                </div>

                <div @click="onShowPickBackground" class="cs-input-file">
                  <div class="cs-select-file">{{ $t("lbl_select_file") }}</div>
                  <div class="flex items-center justify-center flex-1">
                    {{ $t("lbl_no_file_selected") }}
                  </div>
                </div>
                <input
                  v-show="false"
                  id="circle-file-background"
                  class="form-control bg-white border mb-0"
                  name="circle-file-background"
                  type="file"
                  accept="image/*"
                  @change="(e) => onSelectFile(e, 'background')"
                />
              </div>
            </div>
            <div class="d-flex justify-content-end mb-3" v-if="updating_info">
              <button
                class="btn btn-FEF3F2"
                @click="() => (updating_info = false)"
                type="button"
              >
                {{ $t("multidisciplinary_board.btn_cancel") }}
              </button>
              <button
                class="btn bg-pri bd-pri text-white ml-3"
                @click="updateCircle"
                type="button"
              >
                {{ $t("multidisciplinary_board.lbl_save") }}
              </button>
            </div>
            <div class="d-flex mb-3">
              <div class="icinfo">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 16H18V8H6V16ZM8 10H16V14H8V10ZM4 15H2V18C2 19.1 2.9 20 4 20H7V18H4V15ZM4 6H7V4H4C2.9 4 2 4.9 2 6V9H4V6ZM20 4H17V6H20V9H22V6C22 4.9 21.1 4 20 4ZM20 18H17V20H20C21.1 20 22 19.1 22 18V15H20V18Z"
                    fill="#84818A"
                  />
                </svg>
              </div>
              <div class="row w-100">
                <div class="col-6">
                  <p class="fs-14 fw-600 mb-1 mt-1">
                    {{ $t("circle_feature.lbl_circle_code") }}
                  </p>
                  <p class="fs-16 fw-600 mb-0 txt-pri">
                    {{ circle && circle.code }}
                  </p>
                </div>
                <div class="col-6">
                  <p
                    class="fs-14 fw-500 txt-pri text-decoration-underline text-right my-1 cursor-pointer"
                    @click="showQr(true)"
                  >
                    QR code
                  </p>
                  <p class="fs-14 fw-500 mb-0 text-right">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      @click="copyCode(circle && circle.code)"
                      class="cursor-pointer"
                    >
                      <path
                        d="M16.5 1H4.5C3.4 1 2.5 1.9 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.4 5 6.5 5.9 6.5 7V21C6.5 22.1 7.4 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.9 20.6 5 19.5 5ZM19.5 21H8.5V7H19.5V21Z"
                        fill="#1D2939"
                      />
                    </svg>
                  </p>
                </div>
              </div>
            </div>
            <div class="d-flex mb-3">
              <div class="icinfo">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5947 18.2565V13.6353M12.5947 12.6891C12.8067 10.038 11.3857 5.02198 4.00492 6.16728C3.89887 8.34122 5.46835 12.6891 12.5947 12.6891ZM12.5947 12.6891C13.7081 11.5226 15.723 8.56014 20.5 10C20.0654 12.0378 18.3162 14.7488 12.5947 13.6353M12.5947 12.6891V13.6353"
                    stroke="#84818A"
                    stroke-width="2"
                  />
                  <rect x="3" y="18" width="17" height="2" fill="#84818A" />
                </svg>
              </div>
              <div class="row">
                <p class="fs-14 fw-600 mb-1 mt-1">Seed</p>

                <div
                  class="d-flex align-items-center"
                  v-if="circle && circle.seed"
                >
                  <div style="min-width: 40px">
                    <!-- <span
                      v-if="circle.seed.avatar"
                      class="avatar avatar-sm avatar-rounded"
                      :style="
                                'background-image: url(' +
                                getImageURL(circle.seed.avatar) +
                                ')'
                              "
                    ></span>-->
                    <ImageBox
                      v-if="circle.seed && circle.seed.avatar"
                      class="avatar avatar-sm avatar-rounded object-cover object-top border"
                      avatar
                      :source="circle.seed && getImageURL(circle.seed.avatar)"
                      :alt="circle.seed.name"
                    />
                    <span
                      v-if="!circle.seed || !circle.seed.avatar"
                      class="avatar avatar-sm avatar-rounded bg-pri text-white"
                    >
                      {{
                        circle.seed.name.charAt(0) ||
                        circle.seed.email.charAt(0)
                      }}
                    </span>
                  </div>
                  <div class="flex-1">
                    <p class="fs-14 fw-600 txt-black mb-1">
                      {{ circle.seed.name }}
                    </p>
                    <p class="fs-12 fw-500 txt-grey-600 mb-0">
                      {{ circle.seed.doctor && circle.seed.doctor.chuc_vu }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 ml-auto">
            <div
              class="open-chat-att"
              @click="goToAttachment"
              v-if="isMember || isAdmin"
            >
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-2"
              >
                <path d="M8 16H40V36H8V16Z" fill="#20419B" />
                <path
                  d="M40 12H24L20 8H8C5.8 8 4.02 9.8 4.02 12L4 36C4 38.2 5.8 40 8 40H40C42.2 40 44 38.2 44 36V16C44 13.8 42.2 12 40 12ZM40 36H8V16H40V36Z"
                  fill="#20419B"
                />
              </svg>
              <span class="txt-black fs-16 fw-500">
                {{ $t("home_page.lbl_org_resource") }}
              </span>
            </div>
            <div
              class="open-chat-att justify-content-between"
              @click="goToChat"
              v-if="
                (isMember || isAdmin) &&
                circle &&
                circle.type === CIRCLE_TYPE.NORMAL
              "
              :class="[
                unread_message_count ? 'has-unread-chat' : '',
                $conversationsClient &&
                circle &&
                circle.twilio_conversation &&
                circle.twilio_conversation.twilio_conv_id
                  ? ''
                  : 'disabled',
              ]"
            >
              <div class="d-flex align-items-center">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="mr-2"
                >
                  <path d="M30 22V8H8V24.34L10.34 22H12H30Z" fill="#20419B" />
                  <path
                    d="M32 26C33.1 26 34 25.1 34 24V6C34 4.9 33.1 4 32 4H6C4.9 4 4 4.9 4 6V34L12 26H32ZM8 24.34V8H30V22H10.34L8 24.34ZM44 14C44 12.9 43.1 12 42 12H38V30H12V34C12 35.1 12.9 36 14 36H36L44 44V14Z"
                    fill="#20419B"
                  />
                </svg>

                <span
                  :class="
                    unread_message_count
                      ? 'txt-pri fs-20 fw-700'
                      : 'txt-black fs-16 fw-500'
                  "
                  >Chat</span
                >
              </div>
              <p class="mb-0 txt-pri fs-20 fw-700" v-if="unread_message_count">
                +{{ unread_message_count }} {{ $t("circle_feature.lbl_new") }}
              </p>
              <div class="red-dot-new" v-if="unread_message_count">
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8.5" cy="8.5" r="8.5" fill="#D92D20" />
                </svg>
              </div>
            </div>
            <div
              v-if="
                (isMember || isAdmin) && circle && isShowMeetRoom
                // circle.type === CIRCLE_TYPE.NORMAL
              "
              class="open-chat-att"
              @click="goToMeet"
            >
              <div class="d-flex align-items-center">
                <svg
                  class="mx-2"
                  width="36"
                  height="28"
                  viewBox="0 0 36 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M34.0683 4.672C33.3483 4.32 31.838 3.952 29.7834 5.264L27.202 6.928C27.0088 1.952 24.638 0 18.878 0H8.34146C2.33561 0 0 2.128 0 7.6V20.4C0 24.08 2.19512 28 8.34146 28H18.878C24.638 28 27.0088 26.048 27.202 21.072L29.7834 22.736C30.8722 23.44 31.8205 23.664 32.5756 23.664C33.2254 23.664 33.7346 23.488 34.0683 23.328C34.7883 22.992 36 22.08 36 19.792V8.208C36 5.92 34.7883 5.008 34.0683 4.672ZM16.2439 13.008C14.4351 13.008 12.9424 11.664 12.9424 10C12.9424 8.336 14.4351 6.992 16.2439 6.992C18.0527 6.992 19.5454 8.336 19.5454 10C19.5454 11.664 18.0527 13.008 16.2439 13.008Z"
                    fill="#20419B"
                  />
                </svg>

                <span class="txt-black fs-16 fw-500">
                  {{ $t("circle_feature.lbl_circle_meet") }}
                </span>
              </div>
            </div>
            <div
              v-if="
                (isMember || isAdmin) &&
                circle &&
                circle.type === CIRCLE_TYPE.LIVE
              "
              class="open-chat-att"
              @click="handleClickToRoom"
            >
              <div class="d-flex align-items-center">
                <img
                  class="mr-2"
                  :src="liveStream"
                  :alt="circle && circle.name"
                  width="32"
                  height="32"
                />
                <div>
                  <span
                    class="inline-block livestream-redot mb-0"
                    v-if="circle && circle.is_live_stream === 2"
                    >Đang trực tiếp</span
                  >
                  <span class="block txt-black fs-16 fw-500">{{
                    formatterBtnText
                  }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="isAdmin && circle && circle.type === CIRCLE_TYPE.LIVE"
              class="open-chat-att"
              @click="showModalAssignRole('livestream')"
            >
              <div class="d-flex align-items-center">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M53.0667 33.7604C52.6391 33.2737 52.4034 32.6481 52.4034 32.0004C52.4034 31.3526 52.6391 30.727 53.0667 30.2404L56.48 26.4004C56.8561 25.9808 57.0897 25.4529 57.1472 24.8924C57.2047 24.3319 57.0831 23.7675 56.8 23.2804L51.4667 14.0537C51.1864 13.5671 50.7597 13.1814 50.2473 12.9515C49.735 12.7217 49.1631 12.6595 48.6133 12.7737L43.6 13.787C42.9621 13.9188 42.298 13.8126 41.733 13.4884C41.1681 13.1641 40.7413 12.6443 40.5333 12.027L38.9067 7.14704C38.7278 6.61738 38.3869 6.15734 37.9323 5.83195C37.4777 5.50656 36.9324 5.33226 36.3733 5.3337H25.7067C25.1252 5.30335 24.5497 5.46417 24.0682 5.79161C23.5867 6.11904 23.2255 6.59509 23.04 7.14704L21.5467 12.027C21.3387 12.6443 20.9119 13.1641 20.347 13.4884C19.782 13.8126 19.1179 13.9188 18.48 13.787L13.3333 12.7737C12.8121 12.7001 12.2808 12.7823 11.8063 13.0101C11.3317 13.2379 10.9352 13.601 10.6667 14.0537L5.33333 23.2804C5.04309 23.7621 4.91259 24.3233 4.96049 24.8836C5.00838 25.444 5.23222 25.9749 5.6 26.4004L8.98667 30.2404C9.41418 30.727 9.64996 31.3526 9.64996 32.0004C9.64996 32.6481 9.41418 33.2737 8.98667 33.7604L5.6 37.6004C5.23222 38.0259 5.00838 38.5567 4.96049 39.1171C4.91259 39.6775 5.04309 40.2386 5.33333 40.7204L10.6667 49.947C10.9469 50.4336 11.3737 50.8194 11.886 51.0492C12.3984 51.279 12.9702 51.3413 13.52 51.227L18.5333 50.2137C19.1712 50.0819 19.8353 50.1881 20.4003 50.5124C20.9653 50.8366 21.392 51.3564 21.6 51.9737L23.2267 56.8537C23.4122 57.4057 23.7733 57.8817 24.2548 58.2091C24.7364 58.5366 25.3118 58.6974 25.8933 58.667H36.56C37.119 58.6685 37.6644 58.4942 38.119 58.1688C38.5736 57.8434 38.9144 57.3834 39.0933 56.8537L40.72 51.9737C40.928 51.3564 41.3547 50.8366 41.9197 50.5124C42.4847 50.1881 43.1488 50.0819 43.7867 50.2137L48.8 51.227C49.3498 51.3413 49.9216 51.279 50.434 51.0492C50.9464 50.8194 51.3731 50.4336 51.6533 49.947L56.9867 40.7204C57.2698 40.2332 57.3913 39.6689 57.3338 39.1083C57.2764 38.5478 57.0428 38.0199 56.6667 37.6004L53.0667 33.7604ZM49.0933 37.3337L51.2267 39.7337L47.8133 45.6537L44.6667 45.0137C42.7461 44.6211 40.7482 44.9474 39.0522 45.9305C37.3563 46.9137 36.0804 48.4853 35.4667 50.347L34.4533 53.3337H27.6267L26.6667 50.2937C26.0529 48.4319 24.777 46.8603 23.0811 45.8772C21.3851 44.894 19.3873 44.5678 17.4667 44.9604L14.32 45.6004L10.8533 39.707L12.9867 37.307C14.2985 35.8403 15.0238 33.9415 15.0238 31.9737C15.0238 30.0059 14.2985 28.1071 12.9867 26.6404L10.8533 24.2404L14.2667 18.3737L17.4133 19.0137C19.3339 19.4063 21.3318 19.0801 23.0277 18.0969C24.7237 17.1137 25.9996 15.5421 26.6133 13.6804L27.6267 10.667H34.4533L35.4667 13.707C36.0804 15.5688 37.3563 17.1404 39.0522 18.1236C40.7482 19.1067 42.7461 19.433 44.6667 19.0404L47.8133 18.4004L51.2267 24.3204L49.0933 26.7204C47.7962 28.1837 47.0799 30.0715 47.0799 32.027C47.0799 33.9826 47.7962 35.8703 49.0933 37.3337ZM31.04 21.3337C28.9303 21.3337 26.868 21.9593 25.1139 23.1314C23.3598 24.3034 21.9926 25.9693 21.1853 27.9184C20.3779 29.8675 20.1667 32.0122 20.5783 34.0813C20.9899 36.1505 22.0058 38.0511 23.4975 39.5428C24.9893 41.0346 26.8899 42.0505 28.959 42.4621C31.0282 42.8737 33.1729 42.6624 35.122 41.8551C37.071 41.0477 38.7369 39.6806 39.909 37.9264C41.0811 36.1723 41.7067 34.11 41.7067 32.0004C41.7067 29.1714 40.5829 26.4583 38.5825 24.4579C36.5821 22.4575 33.869 21.3337 31.04 21.3337ZM31.04 37.3337C29.9852 37.3337 28.954 37.0209 28.077 36.4349C27.1999 35.8488 26.5163 35.0159 26.1126 34.0413C25.709 33.0668 25.6034 31.9945 25.8091 30.9599C26.0149 29.9253 26.5229 28.975 27.2688 28.2291C28.0146 27.4833 28.965 26.9753 29.9995 26.7695C31.0341 26.5637 32.1064 26.6693 33.081 27.073C34.0555 27.4767 34.8885 28.1603 35.4745 29.0373C36.0605 29.9144 36.3733 30.9455 36.3733 32.0004C36.3733 33.4149 35.8114 34.7714 34.8112 35.7716C33.811 36.7718 32.4545 37.3337 31.04 37.3337Z"
                    fill="#284095"
                  />
                </svg>

                <div class="ml-2">
                  <span class="block txt-black fs-16 fw-500">{{
                    $t("circle_feature.btn_assign_role_livestream_short")
                  }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="isAdmin && circle && circle.type === CIRCLE_TYPE.LIVE"
              class="open-chat-att"
              @click="showModalSendNotification(true)"
            >
              <div class="d-flex align-items-center">
                <svg
                  class="mr-2"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.0001 2C10.6869 2 9.38653 2.25866 8.17328 2.7612C6.96002 3.26375 5.85763 4.00035 4.92904 4.92893C3.05368 6.8043 2.00011 9.34784 2.00011 12C1.99137 14.3091 2.7909 16.5485 4.26011 18.33L2.26011 20.33C2.12135 20.4706 2.02736 20.6492 1.98998 20.8432C1.95261 21.0372 1.97353 21.2379 2.05011 21.42C2.13317 21.5999 2.26781 21.7511 2.43696 21.8544C2.6061 21.9577 2.80211 22.0083 3.00011 22H12.0001C14.6523 22 17.1958 20.9464 19.0712 19.0711C20.9465 17.1957 22.0001 14.6522 22.0001 12C22.0001 9.34784 20.9465 6.8043 19.0712 4.92893C17.1958 3.05357 14.6523 2 12.0001 2ZM12.0001 20H5.41011L6.34011 19.07C6.52636 18.8826 6.6309 18.6292 6.6309 18.365C6.6309 18.1008 6.52636 17.8474 6.34011 17.66C5.0307 16.352 4.21528 14.6305 4.0328 12.7888C3.85032 10.947 4.31205 9.09901 5.33934 7.55952C6.36662 6.02004 7.8959 4.88436 9.66663 4.34597C11.4374 3.80759 13.34 3.8998 15.0503 4.60691C16.7607 5.31402 18.173 6.59227 19.0465 8.22389C19.9201 9.85551 20.201 11.7395 19.8412 13.555C19.4815 15.3705 18.5034 17.005 17.0736 18.1802C15.6439 19.3554 13.8509 19.9985 12.0001 20ZM17.0001 11H7.00011C6.73489 11 6.48054 11.1054 6.293 11.2929C6.10547 11.4804 6.00011 11.7348 6.00011 12C6.00011 12.2652 6.10547 12.5196 6.293 12.7071C6.48054 12.8946 6.73489 13 7.00011 13H17.0001C17.2653 13 17.5197 12.8946 17.7072 12.7071C17.8948 12.5196 18.0001 12.2652 18.0001 12C18.0001 11.7348 17.8948 11.4804 17.7072 11.2929C17.5197 11.1054 17.2653 11 17.0001 11ZM15.0001 15H9.00011C8.73489 15 8.48054 15.1054 8.293 15.2929C8.10547 15.4804 8.00011 15.7348 8.00011 16C8.00011 16.2652 8.10547 16.5196 8.293 16.7071C8.48054 16.8946 8.73489 17 9.00011 17H15.0001C15.2653 17 15.5197 16.8946 15.7072 16.7071C15.8948 16.5196 16.0001 16.2652 16.0001 16C16.0001 15.7348 15.8948 15.4804 15.7072 15.2929C15.5197 15.1054 15.2653 15 15.0001 15ZM9.00011 9H15.0001C15.2653 9 15.5197 8.89464 15.7072 8.70711C15.8948 8.51957 16.0001 8.26522 16.0001 8C16.0001 7.73478 15.8948 7.48043 15.7072 7.29289C15.5197 7.10536 15.2653 7 15.0001 7H9.00011C8.73489 7 8.48054 7.10536 8.293 7.29289C8.10547 7.48043 8.00011 7.73478 8.00011 8C8.00011 8.26522 8.10547 8.51957 8.293 8.70711C8.48054 8.89464 8.73489 9 9.00011 9Z"
                    fill="#20409B"
                  />
                </svg>

                <div class="h-full">
                  <span class="block txt-black fs-16 fw-500">{{
                    $t("lbl_send_notification")
                  }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="isMember || isAdmin"
              @click="handleOpenVideoList"
              class="cursor-pointer flex items-center gap-2 open-chat-att"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 5C2 4.44771 2.44771 4 3 4H21C21.5523 4 22 4.44771 22 5V19C22 19.5523 21.5523 20 21 20H3C2.44771 20 2 19.5523 2 19V5Z"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
                <path
                  d="M18 4V20"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6 4V20"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19 9H22"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19 15H22"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 9H5"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 8V10"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4.5 4H7.5"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4.5 20H7.5"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.5 4H19.5"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.5 20H19.5"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 15H5"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 14V16"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22 14V16"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22 8V10"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.5 9.5L14.5 12L10.5 14.5V9.5Z"
                  stroke="#20409B"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="block txt-black fs-16 fw-500">{{
                $t("lbl_video_playlist")
              }}</span>
            </div>
          </div>
          <CircleSchedule
            class="col-12"
            :isAdmin="isAdmin"
            :seedMember="circle.seed"
          />
          <div class="col-12">
            <template v-if="isMember || isAdmin">
              <div class="d-flex">
                <div class="icinfo">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.67 13.13C18.04 14.06 19 15.32 19 17V20H23V17C23 14.82 19.43 13.53 16.67 13.13Z"
                      fill="#84818A"
                    />
                    <path
                      d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
                      fill="#84818A"
                    />
                    <path
                      d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
                      fill="#84818A"
                    />
                    <path
                      d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
                      fill="#84818A"
                    />
                  </svg>
                </div>
                <div class="row">
                  <p class="fs-14 fw-600 mb-0 mt-1">
                    {{ $t("circle_feature.lbl_circle_member") }}
                  </p>
                </div>
              </div>
            </template>
            <nav
              class="navbar navbar-expand-lg navbar-light bg-white"
              v-if="isMember"
            >
              <a class="navbar-brand d-lg-none" href="#">
                {{
                  activeTab === 4
                    ? $t("circle_feature.lbl_board_of_administrators")
                    : activeTab === 3
                    ? $t("circle_feature.lbl_request_to_join")
                    : activeTab === 2
                    ? $t("circle_feature.lbl_invited_list")
                    : activeTab === 1
                    ? $t("circle_feature.lbl_patient")
                    : $t("multidisciplinary_board.lbl_mems_type_expert")
                }}
              </a>
              <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>

              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                  <li class="nav-item" :class="{ active: activeTab === 0 }">
                    <a
                      class="nav-link fs-14"
                      href="javascript:;"
                      @click="changeTab(0)"
                    >
                      {{ $t("multidisciplinary_board.lbl_mems_type_expert") }}
                      ({{ tabsTotalNumber.specialist_count }})
                    </a>
                  </li>
                  <li
                    v-if="isAdmin"
                    class="nav-item"
                    :class="{ active: activeTab === 4 }"
                  >
                    <a
                      class="nav-link fs-14"
                      href="javascript:;"
                      @click="changeTab(4)"
                    >
                      {{ $t("circle_feature.lbl_board_of_administrators") }} ({{
                        tabsTotalNumber.admin_count
                      }})
                    </a>
                  </li>
                  <li class="nav-item" :class="{ active: activeTab === 1 }">
                    <a
                      class="nav-link fs-14"
                      href="javascript:;"
                      @click="changeTab(1)"
                    >
                      {{ $t("circle_feature.lbl_circle_member") }} ({{
                        tabsTotalNumber.patient_count
                      }})
                    </a>
                  </li>
                  <li
                    v-if="isAdmin"
                    class="nav-item"
                    :class="{ active: activeTab === 2 }"
                  >
                    <a
                      class="nav-link fs-14"
                      href="javascript:;"
                      @click="changeTab(2)"
                    >
                      {{ $t("circle_feature.lbl_invited_list") }} ({{
                        tabsTotalNumber.invited_count
                      }})
                    </a>
                  </li>
                  <li
                    v-if="isAdmin"
                    class="nav-item"
                    :class="{ active: activeTab === 3 }"
                  >
                    <a
                      class="nav-link fs-14"
                      href="javascript:;"
                      @click="changeTab(3)"
                    >
                      {{ $t("circle_feature.lbl_request_to_join") }} ({{
                        tabsTotalNumber.pending_count
                      }})
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
            <div class="table-responsive" v-if="isMember || isAdmin">
              <table
                v-if="members"
                class="table table-vcenter table-mobile-md card-table no--border table-patient-list"
              >
                <thead>
                  <tr>
                    <th style="width: 30%">
                      <span class="txt-grey-600 fs-14 fw-600 whitespace-nowrap">
                        {{ $t("circle_feature.lbl_information") }}
                      </span>
                    </th>
                    <th style="width: 30%">
                      <span class="txt-grey-600 fs-14 fw-600 whitespace-nowrap">
                        {{ $t("circle_feature.lbl_position") }}
                      </span>
                    </th>
                    <th style="width: 30%">
                      <span class="txt-grey-600 fs-14 fw-600 whitespace-nowrap">
                        {{ $t("circle_feature.lbl_workplace") }}
                      </span>
                    </th>
                    <th style="width: 10%">
                      <span
                        class="txt-grey-600 fs-14 fw-600 whitespace-nowrap"
                        v-if="isAdmin"
                      >
                        {{ $t("circle_feature.lbl_action") }}
                      </span>
                      <button
                        type="button"
                        class="btn bg--babyblue txt-pri ml-3 border-0"
                        v-if="activeTab === 3 && requested_members.length"
                        @click="acceptAllMember()"
                      >
                        {{ $t("circle_feature.lbl_agree") }} tất cả
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="isAdmin && activeTab !== 4">
                    <td colspan="4">
                      <div class="btn-add-member" @click="showAddMem(true)">
                        <svg
                          width="42"
                          height="42"
                          viewBox="0 0 42 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="mr-2"
                        >
                          <path
                            opacity="0.1"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z"
                            fill="#20419B"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M21.84 20.1595H27.72C28.1839 20.1595 28.56 20.5355 28.56 20.9995C28.56 21.4634 28.1839 21.8395 27.72 21.8395H21.84V27.7195C21.84 28.1834 21.4639 28.5595 21 28.5595C20.5361 28.5595 20.16 28.1834 20.16 27.7195V21.8395H14.28C13.8161 21.8395 13.44 21.4634 13.44 20.9995C13.44 20.5355 13.8161 20.1595 14.28 20.1595H20.16V14.2795C20.16 13.8155 20.5361 13.4395 21 13.4395C21.4639 13.4395 21.84 13.8155 21.84 14.2795V20.1595Z"
                            fill="#20419B"
                          />
                        </svg>
                        <span>{{ $t("circle_feature.btn_add_member") }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-for="member in members"
                    class="cursor-pointer custom"
                    :key="member.id"
                    :set="(user = member.user_info)"
                  >
                    <td
                      v-if="user"
                      :data-label="$t('circle_feature.lbl_information')"
                      @click="
                        goToProfile(
                          member.user_info &&
                            member.user_info.doctor_infor &&
                            member.user_info.doctor_infor.id
                        )
                      "
                    >
                      <div class="px-3 flex items-center w-full">
                        <div class="mr-2">
                          <!-- <span
                            v-if="user.avatar"
                            class="avatar avatar-rounded mr-0"
                            :style="
                            'background-image: url(' +
                            getImageURL(user.avatar) +
                            ')'
                          "
                          ></span>-->
                          <ImageBox
                            v-if="user.avatar"
                            class="avatar avatar-rounded object-cover object-top border"
                            avatar
                            :source="getImageURL(user.avatar)"
                            :alt="user.name || user.email"
                          />
                          <span
                            v-if="!user.avatar"
                            class="avatar avatar-rounded mr-0"
                          >
                            {{
                              user.name
                                ? user.name.charAt(0)
                                : user.email
                                ? user.email.charAt(0)
                                : "H"
                            }}
                          </span>
                        </div>
                        <p class="flex-1 mb-0 fs-14 fw-600">
                          {{ user.name || user.email }}
                        </p>
                      </div>
                    </td>

                    <td
                      v-if="user"
                      :data-label="$t('circle_feature.lbl_position')"
                    >
                      <p class="mb-0 fs-14 fw-500">
                        {{
                          user.chuc_vu ||
                          (user.doctor_info && user.doctor_info.chuc_vu)
                        }}
                      </p>
                    </td>
                    <td
                      v-if="user"
                      :data-label="$t('circle_feature.lbl_workplace')"
                    >
                      <p class="mb-0 fs-14 fw-500">
                        {{ user && user.doctor_info && user.doctor_info.work }}
                      </p>
                    </td>
                    <td
                      v-if="user"
                      :data-label="$t('circle_feature.lbl_action')"
                    >
                      <div class="d-flex" style="white-space: nowrap">
                        <button
                          type="button"
                          class="btn bg--babyblue txt-pri mr-2 border-0"
                          v-if="activeTab === 1 && user.id != user_id"
                          @click="messageTo(member.user_id, $event, member)"
                        >
                          <span>Chat</span>
                          <div
                            class="spinner-border mx-2 loading-btn-icon"
                            role="status"
                          >
                            <div class="sr-only">
                              {{ $t("schedule_page.lbl_loading") }}...
                            </div>
                          </div>
                        </button>
                        <div v-if="isAdmin" style="white-space: nowrap">
                          <button
                            type="button"
                            class="btn bg--babyblue"
                            v-if="activeTab === 0"
                            @click="handleAssignAdmin(member, 1)"
                          >
                            {{ $t("circle_feature.btn_assign_admin") }}
                          </button>
                          <button
                            type="button"
                            class="btn btn-FEF3F2"
                            v-if="activeTab === 4 && checkNotSeed(member)"
                            @click="handleAssignAdmin(member, 2)"
                          >
                            {{ $t("circle_feature.btn_revoke_admin") }}
                          </button>
                          <button
                            type="button"
                            class="btn btn-FEF3F2"
                            v-if="activeTab === 2"
                            @click="rejectMember(member.id)"
                          >
                            {{ $t("circle_feature.btn_recall") }}
                          </button>
                          <button
                            type="button"
                            class="btn bg--babyblue txt-pri mr-2 border-0"
                            v-if="activeTab === 3"
                            @click="acceptMember(member.id)"
                          >
                            {{ $t("circle_feature.lbl_agree") }}
                          </button>
                          <button
                            type="button"
                            class="btn bg--gray-corl border-0 txt-grey-600"
                            v-if="activeTab === 3"
                            @click="rejectMember(member.id)"
                          >
                            {{ $t("circle_feature.lbl_decline") }}
                          </button>
                          <button
                            type="button"
                            class="btn btn-FEF3F2"
                            v-if="activeTab === 1 && user.id != user_id"
                            @click="rejectMember(member.id)"
                          >
                            {{ $t("circle_feature.btn_delete") }}
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td colspan="4" class="text-center">
                      <a
                        href="javascript:;"
                        class="txt-pri fs-16"
                        v-if="
                          paginationData.page_num < paginationData.total_page
                        "
                        @click="getCircleMembers(true)"
                        >{{ $t("circle_feature.btn_load_more") }}</a
                      >
                      <div
                        class="text-center"
                        v-if="!members.length && !member_loading"
                      >
                        <p class="fs-16 fw-500">
                          {{ $t("circle_feature.lbl_no_member") }}
                        </p>
                      </div>
                      <div class="skeleton-line" v-if="member_loading"></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="loading-wr" v-if="loading">
        <div class="skeleton-line" v-for="i in 15" :key="i + 'loading'"></div>
      </div>
      <div
        class="modal fade"
        id="modalQrcode"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalQrcodeLabel"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-qr modal-dialog-centered"
          role="document"
        >
          <div class="modal-content">
            <qrcode
              v-if="circle && circle.code"
              :value="circle.code"
              :options="{
                width: 280,
                margin: 1,
                color: {
                  dark: '#20419B',
                  light: '#ffffff',
                },
              }"
              style="margin: 0 auto; padding: 6px"
              class
              :text="circle.code"
            ></qrcode>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="modalAddCMem"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalAddCMemLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="d-flex justify-content-between p-3">
              <h5 class="modal-title" id="modalUpdateDiseaseLabel">
                {{
                  activeTab === 0
                    ? $t("circle_feature.btn_add_specialist")
                    : $t("circle_feature.btn_invite_patient")
                }}
              </h5>
              <button
                type="button"
                class="close bg-white border-0"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" class="robo-18-500">&times;</span>
              </button>
            </div>
            <div class="moda-body">
              <CircleAddSpecialist
                v-if="activeTab === 0"
                @refresh="refresh"
                :circle="circle"
              />
              <CircleInvitePatient
                ref="modalInvitePatient"
                v-else
                @refresh="refresh"
                :circle="circle"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="circle && circle_member"
        class="modal fade"
        id="modalAssignRole"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalAddCMemLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="d-flex justify-content-between p-3">
              <h5 class="modal-title" id="modalUpdateDiseaseLabel">
                {{ $t(`circle_feature.btn_assign_role_livestream`) }}
              </h5>
              <button
                type="button"
                class="close bg-white border-0"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" class="robo-18-500">&times;</span>
              </button>
            </div>
            <div class="moda-body">
              <CircleAssignRole
                ref="modalAssignRole"
                v-if="selectedFeature !== null"
                :circle="circle"
                :circle_member="circle_member"
                :doctors="specialist_members"
                :isAdmin="isAdmin"
                :isMyHasAssignRole="isMyHasAssignRole"
                :ctaRefreshRoles="ctaRefreshRoles"
                :selectedFeature="selectedFeature"
                @goToRoom="goToStream"
                @refreshRole="get100msRole"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalSendNotification />
    <CircleVideoList
      ref="CircleVideoList"
      :circle="circle"
      :isAdmin="isAdmin"
      :isMember="isMember"
    />
  </div>
</template>

<script>
import liveStream from '@/assets/images/livestream.png'
import appUtils from '@/utils/appUtils'
import CircleAddSpecialist from '@/components/Circles/CircleAddMember'
import CircleInvitePatient from '@/components/Circles/CircleInvitePatient'
import { CIRCLE_TYPE, isDev } from '@/utils/constants'
import CircleAssignRole from '@/components/Circles/CircleAssignRole'
import CircleSchedule from './CircleSchedule'
import ModalSendNotification from './ModalSendNotification.vue'
import ImageBox from '@/components/Common/Image.vue'
import CircleVideoList from './CircleVideoList.vue'

export default {
  name: 'LiveCircleDetail',
  components: {
    CircleAddSpecialist,
    CircleInvitePatient,
    CircleAssignRole,
    CircleSchedule,
    ModalSendNotification,
    ImageBox,
    CircleVideoList
  },
  data () {
    return {
      circle: null,
      loading: false,
      circle_member: null,
      activeTab: 0,
      specialist_members: [],
      patient_members: [],
      invited_members: [],
      requested_members: [],
      admin_members: [],
      member_loading: false,
      user_id: null,
      unread_message_count: 0,
      activeConversation: null,
      updating_info: false,
      form_edit: {
        name: '',
        description: '',
        logo: null,
        background: null
      },
      liveStream,
      CIRCLE_TYPE,
      params: {
        status: 2,
        role: 2,
        keyword: '',
        page_num: 1,
        page_size: 10,
        circle_id: 0
      },
      member_type: 'specialist_members',
      tabsTotalNumber: {
        specialist_count: 0,
        patient_count: 0,
        invited_count: 0,
        pending_count: 0,
        admin_count: 0
      },
      paginationData: {
        total: 0,
        totalPage: 0
      },
      user_100ms_role: 'viewer',
      ctaRefreshRoles: 0,
      selectedFeature: 'livestream',
      appUtils,
      isShowModalSendNotification: false
    }
  },
  computed: {
    isMember () {
      return !!this.circle_member && this.circle_member.status === 2
    },
    isAdmin () {
      return (
        (!!this.isMember && this.circle_member.role === 1) ||
        this.circle?.created_by === this.user_id
      )
    },
    isMyHasAssignRole () {
      return ![null, '', 'viewer', 'guest', 'hls-viewer'].includes(
        this.circle_member?.one_hundred_ms_role
      )
    },
    members () {
      let activeTab = this.activeTab
      if (activeTab === 0) {
        return this.specialist_members // Chuyên gia
      }
      if (activeTab === 1) {
        return this.patient_members
      }
      if (activeTab === 2) {
        return this.invited_members
      }
      if (activeTab === 3) {
        return this.requested_members
      }
      if (activeTab === 4) {
        return this.admin_members // Ban quản trị
      }
    },
    isShowMeetRoom () {
      return this.circle?.meet_room_id
    },
    formatterBtnText () {
      return appUtils.isJSON(this.user_100ms_role) &&
        (JSON.parse(this.user_100ms_role)[this.selectedFeature] ===
          'presenter' ||
          JSON.parse(this.user_100ms_role)[this.selectedFeature] ===
            'broadcaster')
        ? this.$t('circle_feature.lbl_circle_live')
        : this.circle && this.circle.is_live_stream === 2
          ? this.$t('circle_feature.lbl_circle_live_watch_now')
          : this.$t('circle_feature.lbl_circle_live_watch')
    }
  },
  created () {
    this.user_id = appUtils.getLocalUser().id
    this.prepare()
  },
  mounted () {
    const self = this
    self.$nextTick(() => {
      window.$('#modalAssignRole').on('hidden.bs.modal', () => {
        self.selectedFeature = 'livestream'
      })
    })
  },
  methods: {
    async prepare () {
      try {
        this.loading = true
        let c = await this.showCircle()
        let m = await this.getSeedMember()
        this.get100msRole()
        this.getTabsTotalNumber()
        this.getCircleMembers()
        if (
          ((m && m.status === 2) || c?.created_by === this.user_id) &&
          this.$conversationsClient &&
          c?.twilio_conversation?.twilio_conv_id
        ) {
          this.createConversation(c?.twilio_conversation?.twilio_conv_id)
        }
        // if (
        //   (m && m.status !== 3 && m.role === 1) ||
        //   c?.created_by === appUtils.getLocalUser().id
        // ) {
        //   this.getCircleMembers()
        // }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getCircleMembers (isNext = false) {
      let self = this
      if (!this.$route.params.id) return

      if (!isNext) {
        self[this.member_type] = []
      } else {
        this.params.page_num++
      }

      self.member_loading = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getLiveCircleMembers(this.params)
        .then((r) => {
          if (!isNext) {
            self[this.member_type] = r.data.data
            self.paginationData = r.data.page
          } else {
            self.paginationData = r.data.page
            let old = self[this.member_type]
            let newObj = r.data.data
            self[this.member_type] = old.concat(newObj)
          }
        })
        .catch((e) => {
          console.log(e)
          self.$toast.open({
            message: this.$t('circle_feature.lbl_permission_msg'),
            type: 'warning'
          })
        })
        .finally(() => {
          self.member_loading = false
        })
    },
    async assignMember (circle_member_id, role_name) {
      try {
        // const role = {
        //   [this.selectedFeature]: role_name
        // }
        const role =
          typeof role_name === 'string' && appUtils.isJSON(role_name)
            ? JSON.parse(role_name)
            : {
              [this.selectedFeature]: role_name
            }
        const params = {
          circle_member_id: circle_member_id,
          role: JSON.stringify(role)
        }
        // const params = {
        //   circle_member_id: circle_member_id,
        //   role: role_name
        // }
        const res = await this.$rf
          .getRequest('DoctorRequest')
          .assignConferenceRole(params)
        return res.data
      } catch (error) {
        console.log(error)
      }
    },
    async getSeedMember () {
      try {
        let self = this
        let r = await this.$rf
          .getRequest('DoctorRequest')
          .getMemberByUserId(
            this.$route.params.id,
            appUtils.getLocalUser().id,
            null,
            false
          )
          .then(async (r) => {
            if (
              self.circle?.created_by === self.$user?.id &&
              !r.data?.one_hundred_ms_role
            ) {
              const role =
                self.selectedFeature === 'livestream' ||
                (self.circle?.live_room_id && !this.conferenceRoomStatus)
                  ? {
                    livestream: 'broadcaster'
                  }
                  : {
                    conference: 'presenter'
                  }
              const res = await self.assignMember(
                r.data?.id,
                JSON.stringify(role)
              )
              self.circle_member = {
                ...r.data,
                one_hundred_ms_role:
                  typeof res.data.one_hundred_ms_role === 'string' &&
                  appUtils.isJSON(res.data.one_hundred_ms_role)
                    ? JSON.parse(res.data.one_hundred_ms_role || '{}')
                    : res.data.one_hundred_ms_role
              }
              return r
            }

            self.circle_member = { ...r.data }
            return r
          })
          .catch(() => {
            let r = {
              data: null
            }
            // self.circle_member = null
            return r
          })
        return r?.data
      } catch (error) {
        console.log(error)
      }
    },
    changeTab (t) {
      if (!isNaN(t)) {
        this.activeTab = t
        this.params.page_num = 1
        switch (t) {
          case 0:
            this.params.status = 2
            this.params.role = 2
            this.member_type = 'specialist_members'
            break
          case 1:
            this.params.status = 2
            this.params.role = 3
            this.member_type = 'patient_members'
            break
          case 2:
            this.params.status = 1
            this.params.role = ''
            this.member_type = 'invited_members'
            break
          case 3:
            this.params.status = 0
            this.params.role = ''
            this.member_type = 'requested_members'
            break
          case 4:
            this.params.status = 2
            this.params.role = 1
            this.member_type = 'admin_members'
            break
          default:
            break
        }
        this.getCircleMembers()
        this.getTabsTotalNumber()
      }
    },
    async getTabsTotalNumber () {
      await this.$rf
        .getRequest('DoctorRequest')
        .getTabsTotalNumber(this.circle.id)
        .then((r) => {
          this.tabsTotalNumber = { ...r.data }
        })
        .catch(() => {
          this.tabsTotalNumber = { ...this.tabsTotalNumber }
        })
    },
    goToProfile (id) {
      if (!id) return
      this.$router.push({ name: 'DoctorProfile', params: { id: id } })
    },
    async createConversation (id) {
      this.activeConversation =
        await this.$conversationsClient.getConversationBySid(id)
      this.activeConversation.on('messageAdded', this.getUnreadChat)
      this.getUnreadChat()
    },
    async getUnreadChat () {
      this.unread_message_count =
        (await this.activeConversation.getUnreadMessagesCount()) || 0
    },
    goToList () {
      this.$router.push({ name: 'CircleList' })
    },
    async showCircle () {
      let self = this
      if (!this.$route.params.id) return
      let r = await this.$rf
        .getRequest('DoctorRequest')
        .showCircle(this.$route.params.id)
        .then((r) => {
          const circleType = r.data?.type
          if (circleType === CIRCLE_TYPE.NORMAL) {
            self.$router.replace({
              path: '/circle/' + self.$route.params.id
            })
            return
          }
          self.circle = r.data
          self.form_edit = {
            name: r.data?.name,
            description: r.data?.description,
            logo: r.data?.logo,
            background: r.data?.background
          }
          self.params.circle_id = self.circle.id

          return r
        })
        .catch((e) => {
          console.log(e)
          self.$toast.open({
            message: this.$t('circle_feature.lbl_permission_msg'),
            type: 'warning'
          })
          self.$router.push({ name: 'CircleList' })
          return false
        })
      return r?.data
    },
    copyCode (code) {
      let el_code = document.createElement('input')
      document.body.appendChild(el_code)
      el_code.value = code
      el_code.select()
      el_code.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.$toast.open({
        message: this.$t('multidisciplinary_board.lbl_copied_clipboard'),
        type: 'success'
      })
      el_code.remove()
    },
    showQr (show) {
      window.$('#modalQrcode').modal(show ? 'show' : 'hide')
    },
    showAddMem (show) {
      window.$('#modalAddCMem').modal(show ? 'show' : 'hide')
    },
    async rejectMember (id) {
      let r = confirm(this.$t('circle_feature.lbl_confirm_msg'))
      if (!r) return
      let self = this
      await this.$rf
        .getRequest('DoctorRequest')
        .rejectAndNotifyCircleMember(id)
        .then((r) => {
          self.getTabsTotalNumber()
          self[self.member_type] = self[self.member_type].filter(
            (mem) => mem.id !== id
          )
          self.$toast.open({
            message: this.$t('workspace_setting.lbl_msg_success'),
            type: 'success'
          })
          this.$refs.modalInvitePatient.getListMemberNotInvited()
        })
    },
    async acceptMember (id) {
      let r = confirm(this.$t('circle_feature.lbl_confirm_msg'))
      if (!r) return
      let self = this
      await this.$rf
        .getRequest('DoctorRequest')
        .acceptAndNotifyCircleMember(id)
        .then((r) => {
          self[self.member_type] = self[self.member_type].filter(
            (mem) => mem.id !== id
          )
          self.$toast.open({
            message: this.$t('workspace_setting.lbl_msg_success'),
            type: 'success'
          })
          self.getTabsTotalNumber()
        })
    },
    async acceptAllMember () {
      let r = confirm(this.$t('circle_feature.lbl_confirm_msg'))
      if (!r) return
      let self = this
      await this.$rf
        .getRequest('DoctorRequest')
        .acceptAndNotifyAll(self.circle.id)
        .then((r) => {
          self[self.member_type] = []
          self.$toast.open({
            message: this.$t('workspace_setting.lbl_msg_success'),
            type: 'success'
          })
          self.getTabsTotalNumber()
        })
    },
    async joinCircle () {
      let self = this
      if (!this.circle) return
      await this.$rf
        .getRequest('DoctorRequest')
        .joinCircle(this.circle.id)
        .then((result) => {
          self.prepare()
          self.$toast.open({
            message: this.$t('workspace_setting.lbl_msg_success'),
            type: 'success'
          })
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          self.loading = false
        })
    },
    async deleteCircle () {
      let self = this
      if (!this.circle) return
      let r = prompt(this.$t('circle_feature.lbl_del_confirm'))
      if (!r || r.toLowerCase() !== 'yes') return
      await this.$rf
        .getRequest('DoctorRequest')
        .deleteCircle(this.circle.id)
        .then((result) => {
          self.$toast.open({
            message: this.$t('circle_feature.lbl_deleted_msg'),
            type: 'success'
          })
          self.$router.push({ name: 'CircleList' })
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          self.loading = false
        })
    },
    refresh () {
      this.getTabsTotalNumber()
      this.getCircleMembers()
      this.showAddMem(false)
    },
    getImageURL (a) {
      return appUtils.getImageURL(a)
    },
    goToAttachment () {
      this.$router.push({
        name: 'CircleDocuments',
        params: { id: this.$route.params.id }
      })
    },
    goToChat () {
      this.$router.push({
        name: 'CircleChat',
        params: { id: this.$route.params.id }
      })
    },
    // async goToMeet () {
    //   if (!this.circle.meet_room_id) {
    //     alert(this.$t('circle_feature.lbl_meet_circle_not_exist'))
    //     return
    //   }
    //   const meeting_id = this.circle.meet_room_id
    //   let data = await this.$rf
    //     .getRequest('DoctorRequest')
    //     .showMeetRoom(meeting_id)
    //   if (data.data) {
    //     let dm = ''
    //     if (process.env.NODE_ENV === 'development') {
    //       dm = 'https://dev.meet.hodo.com.vn/#/'
    //     } else {
    //       dm = 'https://meet.hodo.com.vn/#/'
    //     }
    //     let token = appUtils.getLocalToken()
    //     let routeData =
    //       dm + '_app/' + data.data.room?.room_name + '?token=' + token
    //     window.open(routeData, '_blank')
    //   }
    // },
    async goToMeet () {
      if (!this.circle?.meet_room_id) {
        alert(this.$t('lbl_meet_circle_does_not_exist'))
        return
      }
      const meeting_id = this.circle.meet_room_id
      let res = await this.$rf
        .getRequest('DoctorRequest')
        .showMeetRoom(meeting_id)
      if (res.data) {
        const token = appUtils.getLocalToken()

        if (appUtils.isUseLiveHodoV2('meet')) {
          let domainOrigin = window.location?.origin
          let domain = ''
          let baseUrl = process.env.VUE_APP_HODO_LIVE

          if (domainOrigin?.includes('http://localhost')) {
            domain = 'http://localhost:8068'
          } else {
            domain = baseUrl
          }
          // const role = roleObj['conference']
          const room100ms_id = res.data?.room?.room100ms_id
          const routeRaw = `${domain}/redirect.html?token=${token}&room_id=${room100ms_id}&circle_id=${
            this.circle?.id
          }&meet_room_id=${
            this.circle?.meet_room_id
          }&type=meeting&role=${'host'}&lang=${this.$lang}`

          console.log(routeRaw)

          setTimeout(() => {
            window.open(
              routeRaw,
              '_blank',
              'noopener noreferrer'
            )
          })
        } else {
          let dm = ''
          if (isDev) {
            dm = 'https://dev.meet.hodo.com.vn/#/'
          } else {
            dm = 'https://meet.hodo.com.vn/#/'
          }
          let routeData =
            dm + '_app/' + res.data?.room?.room_name + '?token=' + token

          setTimeout(() => {
            window.open(
              routeData,
              '_blank',
              'noopener noreferrer'
            )
          })
        }
      }
    },
    async goToStream () {
      if (!this.circle.live_room_id) {
        alert(this.$t('circle_feature.lbl_live_circle_not_exist'))
        return
      }

      const { id, live_room_id } = this.circle
      await this.get100msRole().then(() => {
        let token = appUtils.getLocalToken()
        let domainOrigin = window.location?.origin
        let dm = ''
        let baseUrl = process.env.VUE_APP_HODO_CONFERENCE
        if (domainOrigin.includes('localhost')) {
          dm = 'http://localhost:3000'
        } else {
          dm = baseUrl
        }

        const roleObj = appUtils.isJSON(this.user_100ms_role)
          ? JSON.parse(this.user_100ms_role)
          : {
            [this.selectedFeature]: this.user_100ms_role
          }
        const role = roleObj[this.selectedFeature]
        const routeRaw = `${dm}/redirect.html?token=${token}&room_id=${live_room_id}&circle_id=${id}&type=streaming&role=${
          role || 'viewer'
        }&lang=${this.$lang}`

        console.log(routeRaw)

        setTimeout(() => {
          window.open(
            routeRaw,
            '_blank',
            'noopener noreferrer'
          )
        })
      })
    },
    async updateCircle () {
      let self = this
      if (!this.circle) return
      if (!this.form_edit.name) {
        alert(this.$t('circle_feature.lbl_please_enter_circle_name'))
        return
      }
      let params = {
        ...this.form_edit,
        name: this.form_edit.name,
        description: this.form_edit.description,
        is_private: this.circle.is_private
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .updateCircle(this.circle.id, params)
        .then(() => {
          self.updating_info = false
          self.prepare()
        })
    },
    async messageTo (id, e, u) {
      let self = this
      let tg = e.currentTarget
      tg.classList.add('loading-btn')
      await this.$rf
        .getRequest('AuthRequest')
        .directChatTo({ partner_user_id: id }, null, false)
        .then((r) => {
          this.$reloadChat++
          if (r?.data?.twilio_conv_id) {
            self.$router.push({
              name: 'ChatPage',
              query: { sid: r?.data?.twilio_conv_id }
            })
          }
        })
        .finally(() => {
          tg.classList.remove('loading-btn')
        })
    },
    showModal (show, modalRef) {
      window.$(modalRef).modal(show ? 'show' : 'hide')
    },
    handleClickToRoom () {
      this.selectedFeature = 'livestream'

      this.goToStream()

      // if (this.isAdmin || this.isMyHasAssignRole) {
      //   this.showModal(true, '#modalAssignRole')
      // } else {
      //   this.goToStream()
      // }
    },
    async get100msRole () {
      await this.$rf
        .getRequest('DoctorRequest')
        .checkMyRoleConferenceRoom({
          circle_id: this.circle.id,
          user_id: this.user_id
        })
        .then((res) => {
          this.user_100ms_role = res.data?.one_hundred_ms_role || 'viewer'
        })
        .catch((e) => {
          console.log(e)
          this.$toast.open({
            message: e,
            type: 'error'
          })
        })
    },
    async uploadFiles (file, circle) {
      const params = {
        file,
        FolderTarget: `circle`,
        IdTarget: circle.id
      }
      const formData = new FormData()

      for (const key in params) {
        formData.append(key, params[key])
      }

      const res = await this.$rf
        .getRequest('DoctorRequest')
        .uploadFileTenant(formData)
      return res.data.fileUrl
    },
    onShowPickFile () {
      window.$('input[id="circle-file-upload"]').trigger('click')
    },
    async onSelectFile (event, targetKey) {
      const res = await this.uploadFiles(event.target.files[0], this.circle)
      this.form_edit[targetKey] = res
    },
    showModalSendNotification (show) {
      // this.isShowModalSendNotification = true
      window.$('#ModalSendNotificationLive').modal(show ? 'show' : 'hide')
    },
    showModalAssignRole (modalType) {
      this.ctaRefreshRoles++
      this.selectedFeature = modalType
      if (this.isAdmin || this.isMyHasAssignRole) {
        this.showModal(true, '#modalAssignRole')
        this.$refs.modalAssignRole.openModal(true)
      }
    },
    async handleAssignAdmin (member, role) {
      if (!member?.id) return
      const label = this.$t(
        role === 1
          ? 'fm_are_you_sure_to_assign_member_as_administrator'
          : 'fm_are_you_sure_to_remove_member_from_administrator',
        {
          name: member?.user_info?.name || member?.user_info?.email || ''
        }
      )

      this.$confirm(label, {
        dangerouslyUseHTMLString: true,
        cancelButtonText: this.$t('lbl_cancel'),
        confirmButtonText: this.$t('lbl_save')
      })
        .then(async () => {
          try {
            const params = {
              circle_member_id: member.id,
              role
            }
            await this.$rf
              .getRequest('DoctorRequest')
              .putAssignCircleAdmin(params)

            this.$toast.open({
              message: this.$t(
                role === 1
                  ? 'circle_feature.msg_assign_admin_success'
                  : 'circle_feature.msg_revoke_admin_success'
              ),
              type: 'success'
            })
            this.refresh()
          } catch (error) {
            this.$toast.open({
              message: this.$t(
                role === 1
                  ? 'circle_feature.msg_assign_admin_error'
                  : 'circle_feature.msg_revoke_admin_error'
              ),
              type: 'error'
            })
            console.log(error)
          }
        })
        .catch(() => {})
    },
    checkNotSeed (member) {
      return member?.user_id !== this.circle?.created_by
    },
    onShowPickLogo () {
      window.$('input[id="circle-file-logo"]').trigger('click')
    },
    onShowPickBackground () {
      window.$('input[id="circle-file-background"]').trigger('click')
    },
    handleOpenVideoList () {
      this.$refs.CircleVideoList.openModal(true)
    }
  },
  destroyed () {
    if (this.activeConversation) {
      this.activeConversation.removeListener(
        'messageAdded',
        this.getUnreadChat
      )
    }
  }
}
</script>

<style scoped lang="scss">
.custom:hover {
  background-color: #e4e7ec;
}
.px {
  padding: 9px 43px;
}
.ml-40 {
  margin-left: 40px;
}
.container {
  width: 1024px;
}
.p-48 {
  padding: 0px 48px 0px 48px;
}
.white-s-pre {
  white-space: pre-wrap;
}
.icinfo {
  margin-right: 16px;
}
.bd-blur-gray {
  border-color: #98a2b3;
}
.nav-item.active a {
  color: #20419b !important;
  font-weight: 500;
}
.modal-dialog.modal-qr {
  position: relative;
  display: table; /* This is important */
  overflow-y: auto;
  overflow-x: auto;
  width: auto;
  min-width: 300px;
}
.btn-FEF3F2 {
  background-color: #fef3f2;
  color: #b42318;
  border-color: #fef3f2;
}
.btn-add-member {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 10px;
  border: 1px dashed #20419b;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  /* Primary */

  color: #20419b;
  padding: 8px;
  cursor: pointer;
}
.open-chat-att {
  padding: 16px;
  display: flex;
  align-items: center;
  background-color: #fafafa;
  width: 100%;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 16px;
  position: relative;
  transition: all 0.3s ease;

  &:hover {
    background-color: #eff4ff;
  }
}

.has-unread-chat {
  background-color: #f2f6ff;
  border: 1px solid #20419b;
}
.red-dot-new {
  position: absolute;
  top: 5px;
  right: 10px;
}
.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.loading-btn-icon {
  display: none;
}
.loading-btn .loading-btn-icon {
  display: block !important;
}
.loading-btn {
  pointer-events: none;
  color: white;
  border-color: #98a2b3 !important;
}
.loading-btn span {
  display: none;
}
.livestream-redot {
  background-color: #d92d20;
  color: white;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 500;
}

.cs-input-file {
  display: flex;
  align-items: center;
  width: 100%;
  height: 46px;
  border: 1px solid rgba(101, 109, 119, 0.16) !important;
  border-radius: 4px;
  cursor: pointer;
}

.cs-select-file {
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(101, 109, 119, 0.16) !important;
  background-color: #f6f8fb;
  width: 20%;
  height: 100%;
  padding: 0 8px;
}
</style>
